import React from "react";
import { Button } from "@/components/ui/button";
export function LoadState({ loading, error, retry }) {
  if (error) return <div role="alert" className="rounded-xl border p-5 my-3">Impossibile aggiornare i dati. <Button variant="outline" onClick={retry}>Riprova</Button></div>;
  if (!loading) return null;
  return <div role="status" aria-live="polite" aria-busy="true" className="rounded-xl border p-5 my-3"><p className="text-sm text-muted-foreground mb-3">Caricamento dei dati…</p><div aria-hidden="true" className="space-y-3 animate-pulse">{[1,2,3].map(i => <div key={i} className="h-5 rounded bg-muted" />)}</div></div>;
}
